// Derive work-time shifts from trips (one virtual shift per driver per day):
//   start_time  = earliest pickup-time of that driver on that day
//   end_time    = latest end-time (fallback start) of that driver on that day
//   duration    = end - start (minutes)
//   trip_count  = number of trips that day
//   vehicles    = unique vehicle labels driven that day

const toMin = (hhmm) => {
  if (!hhmm) return null;
  const m = /^(\d{1,2}):(\d{2})/.exec(hhmm);
  if (!m) return null;
  return parseInt(m[1], 10) * 60 + parseInt(m[2], 10);
};

const durationMin = (start, end) => {
  const sm = toMin(start);
  const em = toMin(end);
  if (sm == null || em == null || em < sm) return null;
  return em - sm;
};

export function deriveShiftsFromTrips(trips) {
  const map = new Map(); // key = `${driver_id}|${date}`
  for (const t of trips || []) {
    if (!t.driver_id || !t.trip_date || !t.start_time) continue;
    const key = `${t.driver_id}|${t.trip_date}`;
    const endCandidate = t.end_time || t.start_time;
    const cur = map.get(key);
    if (!cur) {
      map.set(key, {
        driver_id: t.driver_id,
        driver_name: t.driver_name || "",
        date: t.trip_date,
        start: t.start_time,
        end: endCandidate,
        trip_count: 1,
        vehicles: new Set(t.license_plate ? [t.license_plate] : []),
      });
    } else {
      if (t.start_time < cur.start) cur.start = t.start_time;
      if (endCandidate > cur.end) cur.end = endCandidate;
      cur.trip_count += 1;
      if (t.license_plate) cur.vehicles.add(t.license_plate);
    }
  }
  return Array.from(map.values())
    .map((s) => ({
      driver_id: s.driver_id,
      driver_name: s.driver_name,
      date: s.date,
      start_time: s.start,
      end_time: s.end,
      duration_minutes: durationMin(s.start, s.end),
      trip_count: s.trip_count,
      vehicles: Array.from(s.vehicles),
    }))
    .sort((a, b) => (a.date === b.date ? a.driver_name.localeCompare(b.driver_name) : b.date.localeCompare(a.date)));
}

export function fmtDurationMins(mins) {
  if (mins == null) return "—";
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  return `${h}h ${m}m`;
}
